import Vue from 'vue';

export const SET_ASIDE_PANEL_ERROR = 'SET_ASIDE_PANEL_ERROR';

export default {
  namespaced: true,
  state: {
    errorDetails: [],
  },
  actions: {
    setAsidePanelError({ commit }, errorDetails) {
      commit('SET_ASIDE_PANEL_ERROR', errorDetails);
    },
  },
  getters: {
    getAsidePanelError(state = {}) {
      return state.errorDetails;
    },
  },
  mutations: {
    SET_ASIDE_PANEL_ERROR(state, errorDetails = []) {
      Vue.set(state, 'errorDetails', errorDetails);
    },
  },
};
